import {defineComponent, ref, computed, watch, ComputedRef} from "vue";
import {Mri} from "@/app/mri/shared/services/services";
import DateUtil from "@/app/shared/helpers/date-util";
import { debounce, first } from "lodash";
import * as yup from 'yup';
import {useForm} from 'vee-validate';
import {toTypedSchema} from '@vee-validate/yup';
import {
    klValidationFields,
    ValidationFieldsType
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';

export default defineComponent({
    name: 'KlSearchInvoices',
    props: {
        debounceWait: {
            type: Number,
            default: 500
        }
    },
    setup(props, context) {

        const _schema = yup.object({
            dateFrom: yup.array().kl_required_date().label('Van'),
            dateTo: yup.array().kl_required_date().kl_date_later_then({minDateField: 'dateFrom'}).label('Tot en met'),
            documentReference: yup.string().label('Doc nr'),
        });

        const _form = useForm({
            validationSchema: toTypedSchema(_schema),
            initialValues: {
                dateFrom: [DateUtil.formatDate(DateUtil.now().add(-1, 'year'))],
                dateTo: [DateUtil.formatDate(DateUtil.now())],
                documentReference: '',
            }
        });
        const fields: ValidationFieldsType<typeof _schema> = klValidationFields<typeof _schema>(_schema);

        const dateFrom = fields.dateFrom.getValue<string[]>();
        const dateTo = fields.dateTo.getValue<string[]>();
        const documentReference = fields.documentReference.getValue<string>();

        const watchFields: ComputedRef = computed(() => {
            return [dateFrom.value, dateTo.value];
        });

        const dateFromMaxDate = computed(() => {
            return DateUtil.formatDate(first(dateTo.value));
        });

        const dateToMinDate = computed(() => {
            return DateUtil.formatDate(first(dateFrom.value));
        });


        const _debouncedSearch = debounce(() => onSubmit(), props.debounceWait);

        const _search = () => {
            const emitSearch: Mri.IInvoicesSearchFields = {
                date: {
                    from: DateUtil.parseToDate(dateFrom.value),
                    to: DateUtil.parseToDate(dateTo.value),
                },
                documentReference: documentReference.value
            };
            context.emit("search", emitSearch);
        };

        watch(watchFields, (newSearchValue, oldSearchValue) => {
            if (JSON.stringify(newSearchValue) !== JSON.stringify(oldSearchValue)) {
                onSubmit();
            }
        }, { immediate: false, deep: true });

        watch(documentReference, _debouncedSearch, {immediate: false, deep: true});

        const onSubmit = _form.handleSubmit(_search);

        return {
            onSubmit,
            fields,
            dateFrom,
            dateFromMaxDate,
            dateTo,
            dateToMinDate,
            documentReference,
        };
    },
});
